import Vue from 'vue';
import Vuex from 'vuex';
import { getDbType } from '@/apis/pipelineService/physicalDb'
import { getLogicalList } from '@/apis/pipelineService/logicalDb'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		cityList: [],
		ProvinceCityTreeList: [],
		dbTypeList: [], // 数据库db类型
        logicalList: [], // 逻辑库列表
        logicalListCount: 0, //逻辑库列表数量
	},
	getters: {
		getCityList: state => state.cityList,
		getProvinceCityTreeList: state => state.ProvinceCityTreeList
	},
	mutations: {
		setCityList(state, list) {
			state.cityList = list;
		},
		setProvinceCityTreeList(state, list) {
			state.ProvinceCityTreeList = list
		},
		dbTypeList(state, list) {
			state.dbTypeList = list
		},
		logicalList(state, list) {
			state.logicalList = list
        },
        logicalListCount(state, list) {
            state.logicalListCount = list
        },
	},
	actions: {
		// 数据库db类型
		async getDbTypeList({commit}) {
			let res = await getDbType()
			if(res.code==0) {
				if(res.data.length>0) {
					commit("dbTypeList",res.data)
					return res.data
				}
			}
		},
		// 逻辑库列表
		async getLogicalListFu({commit}, parmas) {
			let res = await getLogicalList({
				...parmas
			})
			if(res.code==0) {
				if(res.data) {
                    commit("logicalList", res.data.records)
                    commit("logicalListCount", res.data.total)
				}
			}
		}
	}
});
